(() => {
  const setOpen = (item, open) => {
    item.classList.toggle('is-open', open);

    const button = item.querySelector('[data-benefit-toggle]');
    if (button) button.setAttribute('aria-expanded', String(open));

    const panel = item.querySelector('.PDP-re-powerful-benefits__expanded');
    if (panel) panel.setAttribute('aria-hidden', String(!open));
  };

  const init = () => {
    document.querySelectorAll('[data-pdp-re-benefits]:not([data-pdp-re-benefits-ready])').forEach((section) => {
      section.setAttribute('data-pdp-re-benefits-ready', 'true');

      section.querySelectorAll('[data-benefit-item]').forEach((item) => {
        item.addEventListener('click', (event) => {
          if (event.target.closest('a')) return;
          setOpen(item, !item.classList.contains('is-open'));
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();